import request from '@/utils/request'

export function listFee(params) {
	return new Promise((resolve, reject) => {
		request({
			url: '/fee.listFee',
			method: 'get',
			params
		}).then(response => {
			const res = response.data
			resolve(res)

		}).catch(error => {
			reject(error)
		})
	})
}

export function listFeeConfigs(params) {
	return new Promise((resolve, reject) => {
		request({
			url: '/feeConfig.listFeeConfigs',
			method: 'get',
			params
		}).then(response => {
			const res = response.data
			resolve(res)

		}).catch(error => {
			reject(error)
		})
	})
}

export function listMonthFee(params) {
	return new Promise((resolve, reject) => {
		request({
			url: '/fee.listMonthFee',
			method: 'get',
			params
		}).then(response => {
			// const res =
			// // console.log(response.data)
			const res = response.data
			console.log("---------group--------------")
			console.log(res)
			resolve(res)

		}).catch(error => {
			reject(error)
		})
	})
}
export function groupByYearMonthWithMap(data) {
	const groups = new Map();

	data.forEach(item => {
		const yearMonth = normalizeToYYYYMM(item.yearAndMonth);
		
		// 可选：跳过无效值
		if (yearMonth == null) return;

		if (!groups.has(yearMonth)) {
			groups.set(yearMonth, []);
		}
		groups.get(yearMonth).push(item);
	});
	
	
	// 按年月升序排序（"YYYY-MM" 格式天然支持 localeCompare）
	const sortedEntries = Array.from(groups.entries()).sort(([a], [b]) =>
		a.localeCompare(b)
	);

	const sortedMap = new Map(sortedEntries);
	console.log(sortedMap); // 仅保留有用的日志
	return Object.fromEntries(sortedMap);
}

function normalizeToYYYYMM(input) {
  if (typeof input !== 'string') return null;
  const trimmed = input.trim();
  
  // 匹配两种常见格式：
  // - YYYY-M 或 YYYY-MM（允许单/双位月）
  // - YYYY/M
  const match = trimmed.match(/^(\d{4})[-/](\d{1,2})$/);
  //                              ^^ 直接写 / 即可
  if (!match) return null;

  const year = match[1];
  const month = String(Number(match[2])).padStart(2, '0'); // 自动去零并补零
  return `${year}-${month}`;
}


